import React, { Component } from 'react'
import { Row, Col, Form, Divider } from 'antd'
import Joi from 'joi'
import { sharedAppStateStore } from 'src/store/AppStateStore'
import { EMAIL_REGEX } from 'src/constants/regex'
import { restrictContentWidth } from 'src/hoc/ContentWidth'
import {
  PageLayout,
  CenterContentRow,
  FjCard,
  DefaultFormItem,
  DefaultInput,
  DefaultButton,
  FjText,
  Heading,
} from 'src/components/Common'
import { observer } from 'mobx-react'
import { observable, makeObservable } from 'mobx'
import { APIProvider } from 'src/network/APIProvider'
import { Colors } from 'src/constants/colors'

@observer
class UnsubscribePage extends Component {
  @observable email = ''
  @observable emailError = null
  @observable success = false

  onEmailChange = (e) => {
    this.email = e.target.value
    this.emailError = null
  }

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  validateEmail() {
    const err = Joi.string()
      .required()
      .regex(EMAIL_REGEX)
      .error(() => new Error('Invalid Email'))
      .validate(this.email).error

    if (err) {
      this.emailError = err.message
    }
    return err
  }

  onSubmit = async () => {
    if (this.validateEmail()) {
      return false
    }

    try {
      await sharedAppStateStore.wrapAppLoading(APIProvider.postUnsubscribe({ email: this.email }))
      this.success = true
    } catch (err) {
      sharedAppStateStore.handleError(err)
    }
  }

  render() {
    return (
      <PageLayout>
        <CenterContentRow>
          <Col xs={18} md={12} lg={10} xl={6}>
            <FjCard paddingVertical>
              <Heading fontSize="large">Unsubscribe</Heading>
              <Row justify="center" align="middle">
                <Col span={22}>
                  <Divider style={{ background: Colors.sharkOpacity10, margin: '10px 0' }} />
                </Col>
              </Row>
              <Form onFinish={this.onSubmit}>
                <Row justify="center">
                  <Col span={20}>
                    <DefaultFormItem title="Email Address" errorMsg={this.emailError}>
                      <DefaultInput
                        placeholder="email"
                        error={!!this.emailError}
                        value={this.email}
                        changed={this.onEmailChange}
                      />
                    </DefaultFormItem>
                  </Col>
                </Row>
                <div>{this.success && <FjText fontSize="medium">You have been successfully unsubscribed!</FjText>}</div>
                <DefaultButton
                  style={{ marginTop: '10px' }}
                  title="Unsubscribe"
                  buttonType="primary"
                  size="medium"
                  clicked={this.onSubmit}
                  disabled={this.emailError || this.success}
                />
              </Form>
            </FjCard>
          </Col>
        </CenterContentRow>
      </PageLayout>
    )
  }
}

export const Unsubscribe = restrictContentWidth(UnsubscribePage)
